import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/dbadmin/statusconfig'
import pathMap from 'src/paths/pathMap'

class DbAdminStatusConfigRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.DB_ADMIN_STATUS_CONFIG_LIST_VIEW,
        component: ViewPage
      },
      {
        exact: true,
        path: pathMap.DB_ADMIN_STATUS_CONFIG_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.DB_ADMIN_STATUS_CONFIG_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.DB_ADMIN_STATUS_CONFIG_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default DbAdminStatusConfigRoute
